import { render, staticRenderFns } from "./St21WarnList.vue?vue&type=template&id=84d066f6&scoped=true&"
import script from "./St21WarnList.vue?vue&type=script&lang=js&"
export * from "./St21WarnList.vue?vue&type=script&lang=js&"
import style0 from "./St21WarnList.vue?vue&type=style&index=0&id=84d066f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d066f6",
  null
  
)

export default component.exports